import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { buildRouteChangeMeta } from 'utils/routeChangeMeta';
import { useRouteChangeEventChannelEmitter } from './use-location-change-event-channel-emitter';

/**
 * Re-emits ROUTE_CHANGE with object/record meta once entity (and optional record) data is available.
 * Mount-time emit without meta still happens via useRouteChangeEventChannelEmitter in the route.
 * Pass `displayId` only on the record page so the list page does not emit record meta.
 */
export const useBreadcrumbRouteMetaEmitter = ({ entity, record, displayId } = {}) => {
  const { id } = useParams();
  const { emitRouteChangeEvent } = useRouteChangeEventChannelEmitter(false);

  useEffect(() => {
    if (!entity) return;
    emitRouteChangeEvent(
      null,
      buildRouteChangeMeta({
        entity,
        record,
        routeParam: id,
        displayId,
      })
    );
  }, [entity, record, id, displayId, emitRouteChangeEvent]);
};
